exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .sUHlL5jDg1-ejlcXC9Ucd{padding:0}._3So06rlWDxvgFBg9HqRKTp{height:calc(100% - 10px)}._2jkN6yGgZsTsLRfhIG0OYp .ms-Panel-content{overflow-y:hidden;height:100%}html[dir] ._2jkN6yGgZsTsLRfhIG0OYp .ms-Panel-content{padding:0!important}._2_DqNvwEvfk-cksXbExAAV{height:100%}", ""]);
// Exports
exports.locals = {
	"todoFlexPaneContent": "sUHlL5jDg1-ejlcXC9Ucd",
	"todoFlexPanePanelContainer": "_3So06rlWDxvgFBg9HqRKTp",
	"todoFlex": "_2jkN6yGgZsTsLRfhIG0OYp",
	"todosPane": "_2_DqNvwEvfk-cksXbExAAV"
};